module.exports = __webpack_public_path__ + "img/5.c27ab84d.jpg";